  import axios              from "axios";
  import { api }            from "../_constants";
  import handleResponse     from "./handleResponse";
  import getVoucherUser     from "./handleVoucherUser";
  import getVoucherData     from "./handleVoucherData";
  import getAppStats        from "./handleAppStats";
  import getAppId           from "./handleAppId";
  import getWebServiceCount from "./handleWebServiceCount";

export const wu_ForgotPassService = {
  wu_omtreqchangepwd,
  wu_omtvalidatecode,
  wu_omtchangepwd
};
//----------------------------------------------------------------------------------------------------
function wu_omtreqchangepwd(reqData) {
  const methName = "wu_omtreqchangepwd ";

  localStorage.setItem("forgotPass_email",reqData.email);

  let LocalUrl = "";
  let rv       = reqData.recaptchaVerify;
//if(rv && rv!=="" && rv!==null){ LocalUrl = api.url + "/wbrestservices-1.0.0/wbservice/omtreqchangepwd?email="+reqData.email+"&country="+reqData.country+"&recaptchaVerify="+rv.replace(/"/g,""); }
//else                          { LocalUrl = api.url + "/wbrestservices-1.0.0/wbservice/omtreqchangepwd?email="+reqData.email+"&country="+reqData.country; }
  LocalUrl = api.url + "/wbrestservices-1.0.0/wbservice/omtreqchangepwd?email="+reqData.email+"&country="+reqData.country;

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
      "appStats"                    : getAppStats(api.webappENV),
      "webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
      "recaptchaVerify"             : rv.replace(/"/g,""),
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = {

  };
  if(api.print_HTTP_URL){console.log(methName+LocalUrl);}
  return axios
    .put(LocalUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
//----------------------------------------------------------------------------------------------------
function wu_omtvalidatecode(reqData) {
  const methName = "wu_omtvalidatecode ";

  localStorage.setItem("forgotPass_code",reqData.code);

  const localUrl = api.url + "/wbrestservices-1.0.0/wbservice/omtvalidatecode";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",//"application/xml",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  // const data = ""+
  // "<reqValidateCode>"+
  //     "<email>"+localStorage.getItem("forgotPass_email")+"</email>"+
  //     "<code>"+reqData.code+"</code>"+
  // "</reqValidateCode>";
  const data = {
    "email" : localStorage.getItem("forgotPass_email"),
    "code"  : reqData.code
  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .put(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
//----------------------------------------------------------------------------------------------------
function wu_omtchangepwd(reqData) {
  const methName = "wu_omtchangepwd ";
  const localUrl = api.url + "/wbrestservices-1.0.0/wbservice/omtchangepwd";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",//"application/xml",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  // const data = ""+
  // "<reqChangePwd>"+
  //     "<email>"+new Buffer(localStorage.getItem("forgotPass_email")).toString('base64')+"</email>"+
  //     "<newPassword>"+new Buffer(reqData.newPassword).toString('base64')+"</newPassword>"+
  //     "<oldPassword>"+new Buffer(reqData.newPassword).toString('base64')+"</oldPassword>"+
  //     "<code>"+localStorage.getItem("forgotPass_code")+"</code>"+
  // "</reqChangePwd>";
  const data = {
    "email"        : new Buffer(localStorage.getItem("forgotPass_email")).toString('base64'),
    "newPassword"  : new Buffer(reqData.newPassword).toString('base64'),
    "oldPassword"  : new Buffer(reqData.newPassword).toString('base64'),
    "code"         : localStorage.getItem("forgotPass_code")
  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .put(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
//----------------------------------------------------------------------------------------------------
